(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.contact-form__form').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      var honeypot = form.querySelector('input[name="contact[website]"]');

      if (honeypot && honeypot.value.trim() !== '') {
        // El campo trampa tiene contenido -> lo llenó un bot, bloqueamos el envío
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
